<template>
  <div class="full-container" id="precise_query">
    <SearchBar
      v-bind:charge-departure="departure"
      v-bind:charge-destination="destination"
      v-bind:charge-Weights="chargeWeight"
      v-bind:charge-Counts="chargeCount"
      v-bind:charge-Volume="volume"
      v-bind:charge-Density="density"
      v-bind:charge-Type="packagingtype"
      v-bind:charge-Airline="airline"
      v-bind:charge-Date="flightdate"
      @update-departure="updateDeparture"
      @update-destination="updateDestination"
      @update-date="updateDate"
      @update-airline="updateAirline"
      @update-packtype="updatePacktype"
      @update-density="updateDensity"
      @update-charge-weight="updateChargeWeight"
      @update-volume="updateVolume"
      @update-charge-count="updateChargeCount"
      @query="query"
    ></SearchBar>
    <div class="main-container pnav" v-if="!yunModel">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><router-link to="/">{{
            $t("header.menu.home")
          }}</router-link></el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $t("home.International") }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main-container precise_main" v-loading="loading">
      <div class="precise_cont">
        <el-table
          ref="table"
          :data="dataSource"
          @sort-change="sortChange"
          cell-class-name="table-cell"
          class="all_table"
          id="some-element"
        >
          <el-table-column label="All Airlines" width="172" class="allair">
            <div slot="header" slot-scope="scope">
              <el-dropdown
                class="qb"
                trigger="click"
                v-if="flags == 'on'"
                @command="handleActive"
              >
                <span class="el-dropdown-link">
                  <span>{{ airlineVal }}</span
                  ><i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <div v-for="item of Airlinelist">
                    <el-dropdown-item
                      :command="composeValue(item.busLineId, 'hs')"
                    >
                      {{ item.busLineId }}
                    </el-dropdown-item>
                  </div>
                  <el-dropdown-item :command="composeValue('', 'hs')">
                    {{ $t("query.all") }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <span v-else>All Airlines</span>
            </div>
            <div slot-scope="scope">
              <div
                @click="
                  handleClickRoute(
                    scope.row.productCode,
                    scope.row.priceSyscode,
                    scope.row.productType,
                    scope.row.departure,
                    scope.row.destination
                  )
                "
                class="precise_air"
              >
                <p>
                  {{ scope.row.airline }}&nbsp;&nbsp;{{
                    scope.row.transportDesc ? scope.row.transportDesc : ""
                  }}
                </p>
                <!-- <p>{{ scope.row.Airlinename }}</p> -->
              </div>
            </div>
          </el-table-column>
          <el-table-column label="Density" width="120" prop="density">
            <div slot-scope="scope">
              <p class="density">
                {{ !!scope.row.densityOrigin ? scope.row.densityOrigin : "-" }}
              </p>
              <p class="pad_left">
                <span v-if="scope.row.Product_type == 'NOR'"></span>
                <span class="fla" v-if="scope.row.productType == 'FLA'">
                  {{ $t("footer.sales") }}
                </span>
              </p>
            </div>
          </el-table-column>
          <el-table-column label="Transportation Route" width="160">
            <div slot="header">
              <el-dropdown
                trigger="click"
                v-if="flags == 'on'"
                @command="handleFliter"
              >
                <span class="el-dropdown-link">
                  <span>{{ carriageVal }}</span
                  ><i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="composeValue(0, 'gj')"
                    >直飞</el-dropdown-item
                  >
                  <el-dropdown-item :command="composeValue(1, 'gj')"
                    >中转</el-dropdown-item
                  >
                  <el-dropdown-item :command="composeValue('', 'gj')">
                    {{ $t("query.all") }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <span v-else>Transportation route</span>
            </div>
            <div slot-scope="scope">
              <p class="Freightroute">{{ scope.row.freightRoute }}</p>
              <div class="moreMsg">
                <el-popover
                  placement="bottom"
                  trigger="click"
                  popper-class="more-popover"
                >
                  <template>
                    <el-table
                      :data="FlightList"
                      class="flight-table"
                      style="width: 100%"
                    >
                      <el-table-column
                        align="center"
                        prop="flightNo"
                        label="Flight Number"
                        width="130"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              !!scope.row.flightNo ? scope.row.flightNo : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="departure"
                        label="Departure"
                        width="120"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              !!scope.row.departure ? scope.row.departure : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" prop="etd" label="ETD">
                        <template slot-scope="scope">
                          <p>{{ !!scope.row.etd ? scope.row.etd : "-" }}</p>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="destination"
                        label="Destination"
                        width="120"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              !!scope.row.destination
                                ? scope.row.destination
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column align="center" prop="eta" label="ETA">
                        <template slot-scope="scope">
                          <p>{{ !!scope.row.eta ? scope.row.eta : "-" }}</p>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="flightPlan"
                        label="Flight Plan"
                        width="150"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              !!scope.row.flightPlan
                                ? scope.row.flightPlan
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="flightModel"
                        label="Aircraft Type"
                        width="106"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              !!scope.row.flightModel
                                ? scope.row.flightModel
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="flightRemark"
                        label="Remark"
                        width="120"
                      >
                        <template slot-scope="scope">
                          <p>
                            {{
                              !!scope.row.flightRemark
                                ? scope.row.flightRemark
                                : "-"
                            }}
                          </p>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                  <el-button
                    slot="reference"
                    type="text"
                    class="flight-btn"
                    @click="
                      getMoreList(
                        scope.row.productCode,
                        scope.row.priceSyscode
                      )
                    "
                  >
                    {{ $t("query.info") }}</el-button
                  >
                </el-popover>
              </div>
            </div>
          </el-table-column>
          <el-table-column
            label="Transit Time"
            width="114"
            ref="flighttime"
            prop="flighttime"
            sortable="custom"
          >
            <div slot-scope="scope">
              <p>{{ scope.row.flightTime }}</p>
            </div>
          </el-table-column>
          <el-table-column
            label="+45"
            width="78"
            ref="q1price"
            prop="q1price"
            sortable="custom"
          >
            <div slot-scope="scope">
              <p class="qprice">
                {{
                  scope.row.q1Price == 0 || scope.row.q1Price == "NaN"
                    ? "-"
                    : "¥" + scope.row.q1Price
                }}
              </p>
              <p class="row_time" v-if="!!scope.row.spaceDesc">
                {{ $t("query.cabin") }}：{{ scope.row.spaceDesc }}
              </p>
            </div>
          </el-table-column>
          <el-table-column
            label="+100"
            width="78"
            ref="q2price"
            prop="q2price"
            sortable="custom"
          >
            <div slot-scope="scope">
              <p>
                {{
                  scope.row.q2Price == 0 || scope.row.q2Price == "NaN"
                    ? "-"
                    : "¥" + scope.row.q2Price
                }}
              </p>
            </div>
          </el-table-column>
          <el-table-column
            label="+300"
            width="78"
            ref="q3price"
            prop="q3price"
            sortable="custom"
          >
            <div slot-scope="scope">
              <p>
                {{
                  scope.row.q3Price == 0 || scope.row.q3Price == "NaN"
                    ? "-"
                    : "¥" + scope.row.q3Price
                }}
              </p>
            </div>
          </el-table-column>
          <el-table-column
            label="+500"
            width="78"
            ref="q4price"
            prop="q4price"
            sortable="custom"
          >
            <div slot-scope="scope">
              <p>
                {{
                  scope.row.q4Price == 0 || scope.row.q4Price == "NaN"
                    ? "-"
                    : "¥" + scope.row.q4Price
                }}
              </p>
            </div>
          </el-table-column>
          <el-table-column
            label="+1000"
            width="78"
            ref="q5price"
            prop="q5price"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            v-if="switchs == 'on'"
            label="Total Cost(CNY)"
            width="124"
            ref="total"
            prop="total"
            key="total1"
          >
            <div>
              <p>-</p>
            </div>
          </el-table-column>
          <el-table-column
            v-else
            label="Total Cost(CNY)"
            width="143"
            ref="total"
            prop="total"
            sortable="custom"
            key="total2"
          >
            <div slot-scope="scope">
              <el-popover
                trigger="hover"
                placement="bottom"
                v-if="scope.row.total && scope.row.total != 0"
              >
                <div class="tp_detail">
                  <p v-for="item of scope.row.chargeList">
                    {{ item.name }}:¥{{ item.price }}
                  </p>
                </div>
                <div slot="reference" class="name-wrapper">
                  <p>
                    <span class="cny">{{ scope.row.total }}</span
                    ><i class="el-icon-arrow-down"></i>
                  </p>
                </div>
              </el-popover>
              <p v-else>-</p>
            </div>
          </el-table-column>
          <el-table-column label="" width="140">
            <div slot-scope="scope">
              <el-button
                class="online_booking"
                @click="
                  handleClickRoute(
                    scope.row.productCode,
                    scope.row.priceSyscode,
                    scope.row.productType,
                    scope.row.departure,
                    scope.row.destination
                  )
                "
                type="primary"
                size="small"
              >
                {{ $t("query.book") }}</el-button
              >
              <div class="hover_icon">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Delay treasure"
                  placement="top"
                  v-if="scope.row.delayTreasure == 1"
                >
                  <i class="iconfont el-icon-eft-ziyuan"></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Trailer"
                  placement="top"
                  v-if="scope.row.trailer == 1"
                >
                  <i class="iconfont el-icon-eft-ziyuan1"></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Customs clearance"
                  placement="top"
                  v-if="scope.row.customsDeclare == 1"
                >
                  <i class="iconfont el-icon-eft-ziyuan2"></i>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="Insured"
                  placement="top"
                  v-if="scope.row.priceInsure == 1"
                >
                  <i class="iconfont el-icon-eft-bianzu"></i>
                </el-tooltip>
              </div>
              <div>
                <p class="valid" v-if="scope.row.productType == 'FLA'">
                  {{ $t("order.startDate") }}:
                  {{
                    !!scope.row.flightDate
                      ? scope.row.flightDate.replace(/-/g, ".")
                      : ""
                  }}
                </p>
                <p class="valid" v-else>
                  {{ $t("order.startDate") }}: 
                  {{ scope.row.startDate.replace(/-/g, ".") }}
                </p>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div class="precise_pagination" v-show="pIdx > 0 && dataSource != []">
        <el-pagination
          class="ldc_pagination"
          :key="pagekey"
          @current-change="handleCurrentChange"
          :current-page.sync="pIdx"
          :page-size="10"
          background
          layout="prev, pager, next"
          :total="pCnt"
        >
        </el-pagination>
      </div>
      <div class="more_list" v-show="!!moreDataSource && showMoreList == true">
        <div class="precise_cont precise_more">
          <p class="more_title">{{ $t("query.moreList") }}</p>
          <el-table
            ref="table"
            :data="moreDataSource"
            @sort-change="sortChange"
            cell-class-name="table-cell"
            :show-header="false"
          >
            <el-table-column label="All Airlines" width="172" class="allair">
              <div slot="header" slot-scope="scope">
                <el-dropdown
                  class="qb"
                  trigger="click"
                  v-if="flags == 'on'"
                  @command="handleActive"
                >
                  <span class="el-dropdown-link">
                    <span>{{ airlineVal }}</span
                    ><i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <div v-for="(item, index) of Airlinelist">
                      <el-dropdown-item
                        :command="composeValue(item.busLineId, 'hs')"
                      >
                        {{ item.busLineId }}
                      </el-dropdown-item>
                    </div>
                    <el-dropdown-item :command="composeValue('', 'hs')"
                      >全部
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <span v-else>All Airlines</span>
              </div>
              <div slot-scope="scope">
                <div
                  @click="
                    handleClickRoute(
                      scope.row.productCode,
                      scope.row.priceSyscode,
                      scope.row.productType,
                      scope.row.departure,
                      scope.row.destination
                    )
                  "
                  class="precise_air"
                >
                  <p>
                    {{ scope.row.airline }}&nbsp;&nbsp;{{
                      scope.row.transportDesc ? scope.row.transportDesc : ""
                    }}
                  </p>
                  <!-- <p>{{ scope.row.Airlinename }}</p> -->
                </div>
              </div>
            </el-table-column>
            <el-table-column label="Density" width="130" prop="density">
              <div slot-scope="scope">
                <p class="density">
                  {{ !!scope.row.densityOrigin ? scope.row.densityOrigin : "-" }}
                </p>
                <p class="pad_left">
                  <span class="fla" v-if="scope.row.productType == 'FLA'">
                    {{ $t("footer.sales") }}
                  </span>
                </p>
              </div>
            </el-table-column>
            <el-table-column label="国际运输段" width="170">
              <div slot="header" slot-scope="scope">
                <el-dropdown
                  trigger="click"
                  v-if="flags == 'on'"
                  @command="handleFliter"
                >
                  <span class="el-dropdown-link">
                    <span>{{ carriageVal }}</span
                    ><i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="composeValue(0, 'gj')"
                      >直飞</el-dropdown-item
                    >
                    <el-dropdown-item :command="composeValue(1, 'gj')"
                      >中转</el-dropdown-item
                    >
                    <el-dropdown-item :command="composeValue('', 'gj')"
                      >全部</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
                <span v-else>国际运输段</span>
              </div>
              <div slot-scope="scope">
                <p class="Freightroute">{{ scope.row.freightRoute }}</p>
                <div class="moreMsg">
                  <el-popover
                    placement="bottom"
                    trigger="click"
                    popper-class="more-popover"
                  >
                    <template>
                      <el-table
                        :data="FlightList"
                        class="flight-table"
                        style="width: 100%"
                      >
                        <el-table-column
                          align="center"
                          prop="flightNo"
                          label="Flight Number"
                          width="130"
                        >
                          <template slot-scope="scope">
                            <p>
                              {{
                                !!scope.row.flightNo ? scope.row.flightNo : "-"
                              }}
                            </p>
                          </template>
                        </el-table-column>
                        <el-table-column
                          align="center"
                          prop="departure"
                          label="Departure"
                          width="120"
                        >
                          <template slot-scope="scope">
                            <p>
                              {{
                                !!scope.row.departure
                                  ? scope.row.departure
                                  : "-"
                              }}
                            </p>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" prop="etd" label="ETD">
                          <template slot-scope="scope">
                            <p>{{ !!scope.row.etd ? scope.row.etd : "-" }}</p>
                          </template>
                        </el-table-column>
                        <el-table-column
                          align="center"
                          prop="destination"
                          label="Destination"
                          width="120"
                        >
                          <template slot-scope="scope">
                            <p>
                              {{
                                !!scope.row.destination
                                  ? scope.row.destination
                                  : "-"
                              }}
                            </p>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" prop="eta" label="ETA">
                          <template slot-scope="scope">
                            <p>{{ !!scope.row.eta ? scope.row.eta : "-" }}</p>
                          </template>
                        </el-table-column>
                        <el-table-column
                          align="center"
                          prop="flightPlan"
                          label="Flight Plan"
                          width="150"
                        >
                          <template slot-scope="scope">
                            <p>
                              {{
                                !!scope.row.flightPlan
                                  ? scope.row.flightPlan
                                  : "-"
                              }}
                            </p>
                          </template>
                        </el-table-column>
                        <el-table-column
                          align="center"
                          prop="flightModel"
                          label="Aircraft Type"
                          width="106"
                        >
                          <template slot-scope="scope">
                            <p>
                              {{
                                !!scope.row.flightModel
                                  ? scope.row.flightModel
                                  : "-"
                              }}
                            </p>
                          </template>
                        </el-table-column>
                        <el-table-column
                          align="center"
                          prop="flightRemark"
                          label="Remark"
                          width="120"
                        >
                          <template slot-scope="scope">
                            <p>
                              {{
                                !!scope.row.flightRemark
                                  ? scope.row.flightRemark
                                  : "-"
                              }}
                            </p>
                          </template>
                        </el-table-column>
                      </el-table>
                    </template>
                    <el-button
                      slot="reference"
                      type="text"
                      class="flight-btn"
                      @click="
                        getMoreList(
                          scope.row.productCode,
                          scope.row.priceSyscode
                        )
                      "
                    >
                      {{ $t("query.info") }}</el-button
                    >
                  </el-popover>
                </div>
              </div>
            </el-table-column>
            <el-table-column
              label="转运时间"
              width="94"
              ref="flighttime"
              prop="flighttime"
              sortable="custom"
            >
              <div slot-scope="scope">
                <p>{{ scope.row.flightTime }}</p>
              </div>
            </el-table-column>
            <el-table-column
              label="+45"
              width="78"
              ref="q1price"
              prop="q1price"
              sortable="custom"
            >
              <div slot-scope="scope">
                <p class="qprice">
                  {{
                    scope.row.q1Price == 0 || scope.row.q1Price == "NaN"
                      ? "-"
                      : "¥" + scope.row.q1Price
                  }}
                </p>
                <p class="row_time" v-if="!!scope.row.spaceDesc">
                  {{ $t("query.cabin") }}：{{ scope.row.spaceDesc }}
                </p>
              </div>
            </el-table-column>
            <el-table-column
              label="+100"
              width="78"
              ref="q2price"
              prop="q2price"
              sortable="custom"
            >
              <div slot-scope="scope">
                <p>
                  {{
                    scope.row.q2Price == 0 || scope.row.q2Price == "NaN"
                      ? "-"
                      : "¥" + scope.row.q2Price
                  }}
                </p>
              </div>
            </el-table-column>
            <el-table-column
              label="+300"
              width="78"
              ref="q3price"
              prop="q3price"
              sortable="custom"
            >
              <div slot-scope="scope">
                <p>
                  {{
                    scope.row.q3Price == 0 || scope.row.q3Price == "NaN"
                      ? "-"
                      : "¥" + scope.row.q3Price
                  }}
                </p>
              </div>
            </el-table-column>
            <el-table-column
              label="+500"
              width="69"
              ref="q4price"
              prop="q4price"
              sortable="custom"
            >
              <div slot-scope="scope">
                <p>
                  {{
                    scope.row.q4Price == 0 || scope.row.q4Price == "NaN"
                      ? "-"
                      : "¥" + scope.row.q4Price
                  }}
                </p>
              </div>
            </el-table-column>
            <el-table-column
              label="+1000"
              width="66"
              ref="q5price"
              prop="q5price"
              sortable="custom"
            >
              <div slot-scope="scope">
                <p :class="textBold == true ? 'Bold' : ''">
                  {{
                    scope.row.q5Price == 0 || scope.row.q5Price == "NaN"
                      ? "-"
                      : "¥" + scope.row.q5Price
                  }}
                </p>
              </div>
            </el-table-column>
            <el-table-column
              v-if="switchs == 'on'"
              label="总费用(CNY)"
              width="124"
              ref="total"
              prop="total"
              key="total1"
            >
              <div slot-scope="scope">
                <p>-</p>
              </div>
            </el-table-column>
            <el-table-column
              v-else
              label="总费用(CNY)"
              width="123"
              ref="total"
              prop="total"
              sortable="custom"
              key="total2"
            >
              <div slot-scope="scope">
                <el-popover
                  trigger="hover"
                  placement="bottom"
                  v-if="scope.row.total && scope.row.total != 0"
                >
                  <div class="tp_detail">
                    <p v-for="(item, index) of scope.row.chargeList">
                      {{ item.name }}:¥{{ item.price }}
                    </p>
                  </div>
                  <div slot="reference" class="name-wrapper">
                    <p>
                      <span class="cny">{{ scope.row.total }}</span
                      ><i class="el-icon-arrow-down"></i>
                    </p>
                  </div>
                </el-popover>
                <p v-else>-</p>
              </div>
            </el-table-column>
            <el-table-column label="" width="100">
              <div slot-scope="scope">
                <el-button
                  class="online_booking"
                  @click="
                    handleClickRoute(
                      scope.row.productCode,
                      scope.row.priceSyscode,
                      scope.row.productType,
                      scope.row.departure,
                      scope.row.destination
                    )
                  "
                  type="primary"
                  size="small"
                >
                  {{ $t("query.book") }}</el-button
                >
                <div class="hover_icon">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Delay treasure"
                    placement="top"
                    v-if="scope.row.delayTreasure == 1"
                  >
                    <i class="iconfont el-icon-eft-ziyuan"></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Trailer"
                    placement="top"
                    v-if="scope.row.trailer == 1"
                  >
                    <i class="iconfont el-icon-eft-ziyuan1"></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Customs clearance"
                    placement="top"
                    v-if="scope.row.customsDeclare == 1"
                  >
                    <i class="iconfont el-icon-eft-ziyuan2"></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="Insured"
                    placement="top"
                    v-if="scope.row.priceInsure == 1"
                  >
                    <i class="iconfont el-icon-eft-bianzu"></i>
                  </el-tooltip>
                </div>
                <div>
                  <p class="valid" v-if="scope.row.productType == 'FLA'">
                    {{ $t("order.startDate") }}:
                    {{
                      !!scope.row.flightDate
                        ? scope.row.flightDate.replace(/-/g, ".")
                        : ""
                    }}
                  </p>
                  <p class="valid" v-else>
                    {{ $t("order.startDate") }}: 
                    {{ scope.row.startDate.replace(/-/g, ".") }}
                  </p>
                </div>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
@import "~@/assets/css/view/product/query.css";
</style>
<script type="babel">
import SearchBar from '@/components/searchBar/index.vue';
import YC_REQUEST_HANDLER from "@/api/request.js";
import { mapState, mapActions, mapGetters } from 'vuex';
import UTILS from "@/utils/utils.js";
import DBUtils from "@/utils/dbUtils.js";
import URLSearchParams from 'url-search-params';
export default {
    components: {
        SearchBar,
    },
    computed: {
        ...mapState({
            user: state => state.user,
            token: state => state.token,
            yunModel: state=> state.yunModel
        }),
        ...mapGetters({
	        login: 'checkLogin',
	    })
    },
    data: function(){
        return {
            dataSource: [],
            datatit: [{
                    type: '销量',
                    val: '1'
                },
                {
                    type: '上架时间',
                    val: '2'
                },
            ],
            pIdx: 1,
            pCnt: 1,
            PageSize: '10',
            CurrentPage: '1',
            orderbyDesc: '',
            orderby: '',
            departure: '',
            destination: '',
            flightdate: '',
            airline: '',
            packagingtype: '',
            density: '',
            chargeWeight: '',
            chargeCount: '',
            volume: '',
            // 始发目的航司
            airLineOptions: [],
            AIRLINE_COLLECTIONS: '',
            switchs: '',
            flags: 'off',
            // 航司
            Airlinelist: '',
            densitystrVal: '密度',
            carriageVal: '国际运输段',
            airlineVal: 'All Airlines',
            // 筛选值
            transit: '', //国际运输段
            densitystr: '', //密度
            pagekey: '1',
            // 滚动
            currentId: 1,
            listName: '',
            loading: false,
            scrollHeight: '',
            FlightList: [],
            baseRateList: [],
            DomainName: '',
            CostDescription: '',
            SeparationRatio: '',
            SingleProductWeight: '',
            WeightBottomLine: '',
            TransportType: '',
            Remark: '',
            moreDataSource:[],
            textBold:false,
            showMoreList:false,
            packagingtype:'',
        }

    },
    mounted:function () {
        var vm = this;
        vm.flags = vm.destination ? 'on' : 'off'
        vm.switchs = vm.chargeCount && vm.destination && vm.departure ? 'off' : 'on'
        // // 置空筛选条件-分页重置
        vm.airlineVal = 'All Airlines';
        vm.densitystrVal = '密度';
        vm.carriageVal = '国际运输段';
        vm.pagekey = Math.ceil(Math.random() * 10);
        vm.orderby = vm.orderbyDesc = vm.transit = vm.densitystr = '';
        var query={
            sublist: 1,
            pageSize: 10,
            currentPage: 1,
            departure: vm.departure,
            destination: vm.destination,
            flightDate: vm.flightdate,
            airline: vm.airline,
            chargeWeight: vm.chargeWeight,
            volume: vm.volume,
            packagingType: vm.packagingtype,
            density: vm.density,
            orderby: '',
            orderbyDesc:'',
            types: 'off',
            logFlag: true,
            densitystr: vm.densitystr,
            transit: vm.transit,
        }
        vm.preciseQuery(query);
    },
    created: function() {
        var vm = this;
        vm.departure = vm.$route.query.departure || ''
        vm.destination = vm.$route.query.destination || ''
        vm.flightdate =  vm.$route.query.flightdate || ''
        vm.airline = vm.$route.query.airline || ''
        vm.chargeWeight =  vm.$route.query.chargeWeight || ''
        vm.volume =  vm.$route.query.volume || ''
        vm.chargeCount =  vm.$route.query.chargeCount || ''
        vm.packagingtype =  vm.$route.query.packagingtype || ''
        vm.density =  vm.$route.query.density || ''
        vm.flags = vm.destination ? 'on' : 'off'
        vm.switchs = vm.chargeCount && vm.destination && vm.departure ? 'off' : 'on'
        // vm.postLog();
    },
    methods: {
        // 始发目的港
        updateDeparture: function (departure) {
            this.departure = departure
        },
        updateDestination: function (destination) {
            this.destination = destination
        },
        updateDate: function (date) {
            this.flightdate = date
        },
        updateAirline: function (airline) {
            this.airline = airline
        },
        updatePacktype: function (packagingtype) {
            this.packagingtype = packagingtype
        },
        updateDensity: function (density) {
            this.density = density
        },
        updateVolume: function (volume) {
            this.volume = volume
        },
        updateChargeWeight: function (chargeWeight) {
            this.chargeWeight = chargeWeight
        },
        updateChargeCount: function (chargeCount) {
            this.chargeCount = chargeCount
        },
        // 动态列表
        handleActive: function (res) {
            var vm =this
            var types = res.type;
            var vals = res.val;
            vm.pagekey = Math.ceil(Math.random() * 10); // 分页重置
            if (types == 'hs') {
                if (vals) {
                    vm.airlineVal = vals;
                } else {
                    vm.airlineVal = 'All Airlines';
                }
                vm.airline = vals;
            }
            var query={
                sublist: vals ? 0 : 1,
                pageSize: vm.PageSize,
                currentPage: 1,
                departure: vm.departure,
                destination: vm.destination,
                flightDate: vm.flightdate,
                airline: vm.airline,
                chargeWeight: vm.chargeWeight,
                volume: vm.volume,
                packagingType: vm.packagingtype,
                density: vm.density,
                orderby: '',
                orderbyDesc:'',
                types: 'off',
                logFlag: false,
                densitystr: vm.densitystr,
                transit: vm.transit,
            }
            vm.preciseQuery(query)
        },
        composeValue: function (val, type) {
            return {
                'val': val,
                'type': type
            }
        },
        // 筛选推荐
        handleFliter: function (res) {
            var vm =this
            var types = res.type;
            var vals = res.val;
            vm.pagekey = Math.ceil(Math.random() * 10); // 分页重置
            switch (vals) {
                case 0:
                    types == 'md' ? vm.densitystrVal = '轻货' : vm.carriageVal = '直飞';
                    break;
                case 1:
                    types == 'md' ? vm.densitystrVal = '平货' : vm.carriageVal = '中转';
                    break;
                case 2:
                    vm.densitystrVal = '重货';
                    break;
                case 4:
                    break;
                default:
                    types == 'md' ? vm.densitystrVal = '密度' : vm.carriageVal = '国际运输段';
            }
            if (types == 'md') {
                vm.densitystr = vals;
            } else {
                vm.transit = vals;
            }
            var query={
                sublist: 0,
                pageSize: vm.PageSize,
                currentPage: 1,
                departure: vm.departure,
                destination: vm.destination,
                flightDate: vm.flightdate,
                airline: vm.airline,
                chargeWeight: vm.chargeWeight,
                volume: vm.volume,
                packagingType: vm.packagingtype,
                density: vm.density,
                orderby: '',
                orderbyDesc:'',
                types: 'off',
                logFlag: false,
                densitystr: vm.densitystr,
                transit: vm.transit,
            }
            vm.preciseQuery(query)
        },
        // 排序
        sortChange: function (e) {
            var vm = this;
            vm.orderby = e.prop;
            if (e.order == 'ascending') {
                vm.orderbyDesc = 'asc';
            } else if (e.order == 'descending') {
                vm.orderbyDesc = 'desc';
            } else {
                vm.orderbyDesc = '';
                vm.orderby = '';
            }
            var query={
                sublist: 0,
                pageSize: vm.PageSize,
                currentPage: vm.CurrentPage,
                departure: vm.departure,
                destination: vm.destination,
                flightDate: vm.flightdate,
                airline: vm.airline,
                chargeWeight: vm.chargeWeight,
                volume: vm.volume,
                packagingType: vm.packagingtype,
                density: vm.density,
                orderby: vm.orderby,
                orderbyDesc: vm.orderbyDesc,
                types: 'off',
                logFlag: false,
                densitystr: vm.densitystr,
                transit: vm.transit,
            }
            vm.preciseQuery(query)

        },
        // 分页
        handleCurrentChange: function (val) {
            var vm=this
            vm.CurrentPage = val;
            vm.pIdx = Number(vm.CurrentPage);
            var query={
                sublist: 0,
                pageSize: vm.PageSize,
                currentPage: vm.CurrentPage,
                departure: vm.departure,
                destination: vm.destination,
                flightDate: vm.flightdate,
                airline: vm.airline,
                chargeWeight: vm.chargeWeight,
                volume: vm.volume,
                packagingType: vm.packagingtype,
                density: vm.density,
                orderby: vm.orderby,
                orderbyDesc: vm.orderbyDesc,
                types: 'off',
                logFlag: false,
                densitystr: vm.densitystr,
                transit: vm.transit,
            }
            vm.preciseQuery(query)
        },
        handleClickRoute: function (Productcode, Syscode, Product_type, departure, destination) {
            let query={
                    productcode: Productcode,
                    pricecode: Syscode,
                    productType: Product_type,
                    departure: departure,
                    destination: destination,
                    yunModel: this.yunModel,
                    flightdate: this.flightdate,
                    volume: this.volume,
                    weight: this.chargeWeight,
                }
            let toProductDetail = this.$router.resolve({ name: 'ProductDetailPage', query: query });
			window.open(toProductDetail.href, this.yunModel ? '_self' : '_blank');

        },
        preciseQuery: function (query) {
            //促销专区的数据
            window.scrollTo(0,0)
            var vm = this
            vm.loading = true;
            vm.flags = query.destination ? 'on': 'off'
            vm.switchs = vm.chargeCount && query.destination && query.departure ? 'off' : 'on'
            if (query.types == 'on') {
                vm.airlineVal = 'All Airlines';
                vm.densitystrVal = '密度';
                vm.carriageVal = '国际运输段';
                vm.pagekey = Math.ceil(Math.random() * 10);
                vm.$refs.flighttime.columnConfig.order = '';
                vm.$refs.q1price.columnConfig.order = '';
                vm.$refs.q2price.columnConfig.order = '';
                vm.$refs.q3price.columnConfig.order = '';
                vm.$refs.q4price.columnConfig.order = '';
                vm.$refs.q5price.columnConfig.order = '';
                vm.$refs.total.columnConfig.order = '';
                vm.orderby = vm.orderbyDesc = vm.transit = vm.densitystr = '';
            }
            vm.textBold=!(!!query.destination&&!!query.departure&&!!query.chargeWeight&&!!query.volume)
            vm.showMoreList=(!!query.destination&&!!query.departure)
            !!query.destination&&!!query.departure&&vm.morePreciseQuery(query)

            var params={
                departure: query.departure ? query.departure : '',
                destination: query.destination ? query.destination : '',
                // transit: query.transit || query.transit == 0 ? query.transit : '',
                airline: query.airline ? query.airline :'',
                density: query.density ? query.density : '',
                // densityStr: query.densitystr || query.densitystr == 0 ? query.densitystr : '',
                packagingType: query.packagingtype ? query.packagingtype :'',
                flightDate: query.flightDate ? query.flightDate :'',
                grossWeight: query.chargeWeight ? query.chargeWeight : 0,
                volume: query.volume ? query.volume : 0,
                orderByColumn: query.orderby ? query.orderby :'',
                orderRule: query.orderbyDesc ? query.orderbyDesc : '',
                notProductCode: '',
                sublist: query.sublist,
                pageIndex: query.currentPage,
                pageSize: query.pageSize,
                requestSource: 'WEB-YCTOP',
                logFlag: query.logFlag,
                token: vm.token ? vm.token : ''
            }
            var url = '/api/product/query/list';
            var successCallBack = async function (response) {
                vm.loading = false
                var pIdx = response.pageIndex;
                var pCnt = response.pages;
                if (response.airlineList) {
                    var Airlinelists = response.airlineList.reduce(function (res, item) {
                        res.push({
                            busLineId: item
                        })
                        return res;
                    }, []);
                    vm.Airlinelist = Airlinelists;
                }
                vm.pIdx = Number(pIdx);
                vm.pCnt = Number(pCnt) * 10;
                if (response.productList && response.productList.length>0) {
                    vm.dataSource = [];
                    if (response.productList.length > 0) {
                        vm.dataSource = response.productList;

                    } else {
                        var ChargeArr = [];
                        ChargeArr.push(response.productList)
                        vm.dataSource = ChargeArr;
                    }

                } else {
                    vm.dataSource = [];
                    setTimeout(function () {
                        window.KF5SupportBoxAPI.open();
                    }, 1500);

                }
                let tmpDataSource = []
                for(var i = 0,len=vm.dataSource.length; i < len; i++) {
                // for (var i = 0; i < vm.dataSource.length; i++) {
                    var temp = vm.dataSource[i];
                    // temp.density = UTILS.getDensity(temp.density);
                    temp.densityOrigin = temp.density
                    if(temp.densityOrigin) {
                        let o = temp.densityOrigin,
                            dArray = o.split("<"),
                            t = ''
                        if(dArray.length == 3) {
                            t = dArray[0].replace('=', '') + '<' + dArray[1].replace('=', '') + '≤' + dArray[2].replace('=', '')
                        } else if (dArray.length == 2) {
                            t = dArray[1].replace('=', '') + '≥' + dArray[0].replace('=', '')
                        }
                        t && (temp.densityOrigin = t)
                    }
                    temp.q1Price = parseFloat(temp.q1Price).toFixed(2);
                    temp.q2Price = parseFloat(temp.q2Price).toFixed(2);
                    temp.q3Price = parseFloat(temp.q3Price).toFixed(2);
                    temp.q4Price = parseFloat(temp.q4Price).toFixed(2);
                    temp.q5Price = parseFloat(temp.q5Price).toFixed(2);
                    if(!vm.login && !vm.yunModel && temp.productType!='FLA' ){
                        temp.q1Price = UTILS.replacePosition(temp.q1Price)
                        temp.q2Price = UTILS.replacePosition(temp.q2Price)
                        temp.q3Price = UTILS.replacePosition(temp.q3Price)
                        temp.q4Price = UTILS.replacePosition(temp.q4Price)
                        temp.q5Price = UTILS.replacePosition(temp.q5Price)
                    }
                    temp.startDate = temp.startDate.substring(0, 10);
                    temp.endDate = temp.endDate.substring(0, 10);
                    if (temp.chargeList) {
                        for (var k = 0; k < temp.chargeList.length; k++) {
                            if (temp.chargeList[0].price == 0) {
                                temp.total = 0
                            }
                        }
                    }
                    await DBUtils.getAirlineZhName(temp.airline).then(res=>{
                        temp.Airlinename=res
                    });
                    tmpDataSource.push(temp)
                }
                vm.dataSource = tmpDataSource
            }
            var failCallBack = function (err) {
                vm.loading = false
            }
            YC_REQUEST_HANDLER.postQuery(url, params, successCallBack, failCallBack)
        },
        showPriceDriver: function() {
            if (!this.login && !this.yunModel && !window.localStorage.hideProductPrice) {
                return true
            }
            return false
        },
        morePreciseQuery: function (query) {
            //促销专区的数据
            var vm = this
            vm.flags = query.destination ? 'on': 'off'
            vm.switchs = vm.chargeCount && query.destination && query.departure ? 'off' : 'on'
            if (query.types == 'on') {
                vm.airlineVal = 'All Airlines';
                vm.densitystrVal = '密度';
                vm.carriageVal = '国际运输段';
                vm.$refs.flighttime.columnConfig.order = '';
                vm.$refs.q1price.columnConfig.order = '';
                vm.$refs.q2price.columnConfig.order = '';
                vm.$refs.q3price.columnConfig.order = '';
                vm.$refs.q4price.columnConfig.order = '';
                vm.$refs.q5price.columnConfig.order = '';
                vm.$refs.total.columnConfig.order = '';
                vm.orderby = vm.orderbyDesc = vm.transit = vm.densitystr = '';
            }
            var params={
                departure: query.departure ? query.departure : '',
                destination: query.destination ? query.destination : '',
                // transit: query.transit || query.transit == 0 ? query.transit : '',
                airline: query.airline ? query.airline :'',
                density: query.density ? query.density : '',
                // densityStr: query.densitystr || query.densitystr == 0 ? query.densitystr : '',
                packagingType: query.packagingtype ? query.packagingtype :'',
                flightDate: query.flightDate ? query.flightDate :'',
                grossWeight: query.chargeWeight ? query.chargeWeight : 0,
                volume: query.volume ? query.volume : 0,
                orderByColumn: query.orderby ? query.orderby :'',
                orderRule: query.orderbyDesc ? query.orderbyDesc : '',
                notProductCode: '',
                sublist: query.sublist,
                pageIndex: query.currentPage,
                pageSize: query.pageSize,
                requestSource: 'WEB-YCTOP',
                logFlag: false,
                moreDepsFlag: true,
                token: vm.token ? vm.token : ''
            }
            var url = '/api/product/query/list';
            var successCallBack = async function (response) {
                if (response.productList.length ) {
                    vm.moreDataSource = [];
                    if (response.productList.length > 0) {
                        vm.moreDataSource = response.productList;

                    } else {
                        var ChargeArr = [];
                        ChargeArr.push(response.productList)
                        vm.moreDataSource = ChargeArr;
                    }

                } else {
                    vm.moreDataSource = [];

                }
                let tmpDataSource = []
                for(var i = 0,len=vm.moreDataSource.length; i < len; i++) {
                    var temp = vm.moreDataSource[i];
                    temp.densityOrigin = temp.density
                    if(temp.densityOrigin) {
                        let o = temp.densityOrigin,
                            dArray = o.split("<"),
                            t = ''
                        if(dArray.length == 3) {
                            t = dArray[0].replace('=', '') + '<' + dArray[1].replace('=', '') + '≤' + dArray[2].replace('=', '')
                        } else if (dArray.length == 2) {
                            t = dArray[1].replace('=', '') + '≥' + dArray[0].replace('=', '')
                        }
                        t && (temp.densityOrigin = t)
                    }
                    temp.q1Price = parseFloat(temp.q1Price).toFixed(2);
                    temp.q2Price = parseFloat(temp.q2Price).toFixed(2);
                    temp.q3Price = parseFloat(temp.q3Price).toFixed(2);
                    temp.q4Price = parseFloat(temp.q4Price).toFixed(2);
                    temp.q5Price = parseFloat(temp.q5Price).toFixed(2);
                    if(!vm.login && !vm.yunModel && temp.productType!='FLA'){
                        temp.q1Price = UTILS.replacePosition(temp.q1Price)
                        temp.q2Price = UTILS.replacePosition(temp.q2Price)
                        temp.q3Price = UTILS.replacePosition(temp.q3Price)
                        temp.q4Price = UTILS.replacePosition(temp.q4Price)
                        temp.q5Price = UTILS.replacePosition(temp.q5Price)
                    }
                    temp.startDate = temp.startDate.substring(0, 10);
                    temp.endDate = temp.endDate.substring(0, 10);
                    if (temp.chargeList) {
                        for (var k = 0; k < temp.chargeList.length; k++) {
                            if (temp.chargeList[0].price == 0) {
                                temp.total = 0
                            }
                        }
                    }
                    await DBUtils.getAirlineZhName(temp.airline).then(res=>{
                        temp.Airlinename=res
                    });
                    tmpDataSource.push(temp)
                }
                vm.moreDataSource = tmpDataSource
            }
            var failCallBack = function (err) {

            }
            YC_REQUEST_HANDLER.postQuery(url, params, successCallBack, failCallBack)
        },
        // 航班列表
        getMoreList: function (productcode, price_syscode) {
            var url = '/api/product/query/detail',
                formData={
                    productCode: productcode,
                    priceCode: price_syscode,
                },
                successCallBack = function (response) {
                if (response.flightInfo) {
                    let flightList=[]
                    if(response.flightInfo.first){
                        flightList=flightList.concat(response.flightInfo.first);
                    }
                    if(response.flightInfo.second){
                        flightList=flightList.concat(response.flightInfo.second);
                    }
                    if(response.flightInfo.third){
                        flightList=flightList.concat(response.flightInfo.third);
                    }
                    _this.FlightList = flightList;
                    
                } else {
                    _this.FlightList = [];
                }

                },
                failCallBack = function (err) {

                },
                _this = this
            YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack)

        },
        // 其他信息
        getOtherList: function (productcode, departure, destination, priceSyscode) {
            var url = '/api/product/query/detail',
                formData={
                    productCode: productcode,
                    departure: departure,
                    destination: destination
                },
                successCallBack = function (response) {
                    if (response.priceList.length) {
                        if (response.priceList.length > 0) {
                            _this.baseRateList = response.priceList;
                        } else {
                            var SpiArr = [];
                            SpiArr.push(response.priceList)
                            _this.baseRateList = SpiArr;
                        }
                    }
                    for (var i = 0; i < _this.baseRateList.length; i++) {
                        if (_this.baseRateList[i].priceCode == priceSyscode) {
                            _this.DomainName = _this.baseRateList[i].domainName;
                            _this.CostDescription = _this.baseRateList[i].costDescription;
                            _this.SeparationRatio = _this.baseRateList[i].separationRatio;
                            _this.SingleProductWeight = _this.baseRateList[i].singleProductWeight;
                            _this.WeightBottomLine = _this.baseRateList[i].weightBottomLine;
                            _this.TransportType = _this.baseRateList[i].transportType;
                            _this.Remark = _this.baseRateList[i].remark;
                        }
                    }

                },
                failCallBack = function (err) {

                },
                _this = this

            YC_REQUEST_HANDLER.postQuery(url, formData, successCallBack, failCallBack)

        },
        postLog: function () {
            var vm = this;
            var requestFrom = document.referrer;
            if (requestFrom.indexOf("?") > -1) {
                requestFrom = requestFrom.substring(0, requestFrom.indexOf("?"));
            }
            var requestTo = window.location.href;
            if (requestTo.indexOf("?") > -1) {
                requestTo = requestTo.substring(0, requestTo.indexOf("?"));
            }
            var actionType = "LIST";
            var businessCode = "NOR";
            var phoneNo = vm.user.mobile
            var phoneNoAttribution = "";
            var departure = "";
            var destination = "";
            var productPrice = "";
            var requesterIp = window.sessionStorage.getItem('clientIP');

            var params = new URLSearchParams();
            params.append("requestFrom", requestFrom);
            params.append("requestTo", requestTo);
            params.append("actionType", actionType);
            params.append("businessCode", businessCode);
            params.append("phoneNo", phoneNo);
            params.append("phoneNoAttribution", phoneNoAttribution);
            params.append("departure", departure);
            params.append("destination", destination);
            params.append("productPrice", productPrice);
            params.append("requesterIp", requesterIp);
            !!vm.token && params.append('token', vm.token)
            YC_REQUEST_HANDLER.LogAccess(params);
        },

    }
};
</script>
<style></style>
